module.exports = __webpack_public_path__ + "img/adv_generator_shop.3cc973bc.svg";